import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ExecuteService } from 'src/app/Services/execute.service';
import { RestService } from 'src/app/Services/rest.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ze-visual-comparison',
  templateUrl: './visual-comparison.component.html',
  styleUrls: ['./visual-comparison.component.scss']
})
export class VisualComparisonComponent implements OnInit {
  @Input() isDb2: boolean=false;
  @Input() statusModel: any;
  @Input() expandStep: number;
  @Input() reportStatus: any;
  @Input() reportId: any;
  @Input() browser: any;
  @Input() iteration: any;
  dbName: any;
  stepsData: any[] = [];
  showPopup = false;
  image1Url: string;
  image2Url: string;
  showDiffImg: boolean;
  visual: boolean;

  // collapsed: boolean = false;
  loopsData: any[] = [];
  redBoxes: any[] = [];
  imageData: any = null
  boundaryBoxes: any[] = []; // Define boundaryBoxes as an array
  coordinates: { x: number; y: number; width: number; height: number }[] = [];

  constructor(private executeService: ExecuteService,
    private restService: RestService,
    private httpClient: HttpClient,
  ) { }

  expandAllDetails() {
    const detailsElements = document.querySelectorAll('details');
    detailsElements.forEach((detailsElement: HTMLDetailsElement) => {
      detailsElement.open = true;
    });
    const loopElements = document.querySelectorAll('[name*="loopList."]');
    loopElements.forEach((loopElement: HTMLElement) => {
      loopElement.style.display = "block";
    });
  }

  collapseAllDetails() {
    const detailsElements = document.querySelectorAll('details');
    detailsElements.forEach((detailsElement: HTMLDetailsElement) => {
      detailsElement.open = false;
    });
    const loopElements = document.querySelectorAll('[name*="loopList."]');
    loopElements.forEach((loopElement: HTMLElement) => {
      loopElement.style.display = "none";
    });
  }

  ngOnInit() {
    this.updateStepsData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStepsData();
  }

  updateStepsData() {
    this.executeService.getDifference(this.statusModel, this.reportId).subscribe(data => {
      const diff: string[] = data["data"];
      let stepOrder = 1;
      let commandStepOrder = 1;
      let tempStepsData = [];
      this.statusModel.structure.forEach(struct => {
        if (struct._type === "feature") {
          if (struct.structure != undefined
            && struct.structure.length > 0) {
            struct.structure.forEach(featStruct => {
              if (featStruct._type === "scenario") {
                if (featStruct.structure != undefined
                  && featStruct.structure.length > 0) {
                  featStruct.structure.forEach(scenarioStruct => {
                    scenarioStruct["order"] = stepOrder++;
                    scenarioStruct["suiteName"] = this.statusModel.name;
                    scenarioStruct["stepName"] = struct.name + ' > ' + featStruct.name + ' > ' + scenarioStruct.name;
                    scenarioStruct.commandStepsData.forEach(commandStep => {
                        if (
                          commandStep.visual_diff
                        ) {
                            commandStep["visualStatus"] = true;
                        } else {
                            commandStep["visualStatus"] = false;
                        }
                      commandStep["order"] = commandStepOrder++;
                      commandStep["imageName"] = (this.statusModel["artifact_id"]?this.statusModel["artifact_id"]:this.statusModel["_id"]) + "_" + struct._id + '_' + featStruct._id + '_' + scenarioStruct._id + '_' + commandStep["_id"];                    });
                    tempStepsData.push(scenarioStruct);
                  });
                }
              } else if (featStruct._type === "step") {
                featStruct["order"] = stepOrder++;
                featStruct["suiteName"] = this.statusModel.name;
                featStruct["stepName"] = struct.name + ' > ' + featStruct.name;
                featStruct.commandStepsData.forEach(commandStep => {
                  if (
                    commandStep.visual_diff
                ) {
                    commandStep["visualStatus"] = true;
                } else {
                    commandStep["visualStatus"] = false;
                }
                  commandStep["order"] = commandStepOrder++;
                  commandStep["imageName"] = (this.statusModel["artifact_id"]?this.statusModel["artifact_id"]:this.statusModel["_id"]) + "_" + struct._id + '_' + featStruct._id + '_' + commandStep["_id"];                });
                tempStepsData.push(featStruct);
              }
            });
          }
        } else if (struct._type === "scenario") {
          if (struct.structure != undefined
            && struct.structure.length > 0) {
            struct.structure.forEach(scenarioStruct => {
              scenarioStruct["order"] = stepOrder++;
              scenarioStruct["suiteName"] = this.statusModel.name;
              scenarioStruct["stepName"] = struct.name + ' > ' + scenarioStruct.name;
              scenarioStruct.commandStepsData.forEach(commandStep => {
                if (
                  commandStep.visual_diff
              ) {
                  commandStep["visualStatus"] = true;
              } else {
                  commandStep["visualStatus"] = false;
              }
                commandStep["order"] = commandStepOrder++;
                commandStep["imageName"] = (this.statusModel["artifact_id"]?this.statusModel["artifact_id"]:this.statusModel["_id"]) + "_" + struct._id + '_' + scenarioStruct._id + '_' + commandStep["_id"];              });
              tempStepsData.push(scenarioStruct);
            });
          }
        } else if (struct._type === "step") {
          struct["order"] = stepOrder++;
          struct["suiteName"] = this.statusModel.name;
          struct["stepName"] = struct.name;
          struct.commandStepsData.forEach(commandStep => {
            if (
              commandStep.visual_diff
          ) {
              commandStep["visualStatus"] = true;
          } else {
              commandStep["visualStatus"] = false;
          }
            commandStep["order"] = commandStepOrder++;
            commandStep["imageName"] = (this.statusModel["artifact_id"]?this.statusModel["artifact_id"]:this.statusModel["_id"]) + "_" + struct._id + '_' + commandStep["_id"];
                        if (Array.isArray(commandStep)) {
              this.processCommandStepsArray(commandStep, commandStep["order"], diff);
            }
          });
          tempStepsData.push(struct);
        }
      });
      this.stepsData = tempStepsData;
    });
  }

  processCommandStepsArray(iterationsArray, orderPrefix, diff) {
    iterationsArray.forEach((iterationCommandStepsArray, iteration) => {
      iterationCommandStepsArray.forEach((commandStep, childIndex) => {
        commandStep["order"] = orderPrefix + "_" + (iteration + 1) + "_" + (childIndex + 1);
        if (
          commandStep.visual_diff
      ) {
          commandStep["visualStatus"] = true;
      } else {
          commandStep["visualStatus"] = false;
      }
        if (Array.isArray(commandStep)) {
          this.processCommandStepsArray(commandStep, commandStep["order"], diff);
        }
      });
    });
  }

  openPopup() {
    this.showPopup = true;
    // document.body.style.zoom = "0.4"; // Set zoom to 50% when opening the popup
  }

  closePopup() {
      this.showPopup = false;
      // document.body.style.zoom = "1.0";
  }

  openImages(ctv) {
    this.image1Url = null;
    this.image2Url = null;
    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');

    // Fetch images
    this.httpClient.get(this.restService.apis.getVisualComparisonImagesUrl.url + 
      (this.statusModel["artifact_id"]?this.statusModel["artifact_id"]:this.statusModel["_id"]) + "/" + this.reportId + "/" + this.browser + "/" + 
        this.iteration + "/" + ctv["imageName"],    
        { headers: httpHeaders, responseType: 'json' }
    ).subscribe(data => {
        console.log("Image API Response:", data);
        
        if (data["data"] && data["data"].length > 0) {
          
            // Check if the status is "pass" (visualStatus is false)
            if (!ctv.visualStatus) {
                // For pass status, show only the first image
                this.image1Url = data["data"][0];
                this.image2Url = null;
            } else {
                // For fail status (visualStatus is true), show executed image and diff image
                this.image1Url = data["data"][2]; // Executed image
                // let diffImage = data["data"].find(url => url.includes("difference"));
                this.image2Url = data["data"][0] || null;
            }
            
        } else {
            this.image1Url = null;
            this.image2Url = null;
        }

        this.showPopup = true;

        // Fetch boundary box data
        if(this.isDb2===true){
          this.dbName="db2";
        } else{
          this.dbName="db1";
        }
        // let imageIds= this.image2Url ? this.image2Url.split('/').pop().split('?')[0] : null;
        let imageIds = ctv["imageName"];

        let params = new HttpParams()
          .set('executionId', this.reportId)
          .set('dbName', this.dbName)
          .set('browser', this.browser)
          .set('iteration', this.iteration)
          .set('imageId', imageIds);

        this.httpClient.get(this.restService.apis.getBoundaryBox.url, { 
          headers: httpHeaders,
          params: params,
          responseType: 'json'
        })
        .subscribe({
          next: (boundaryData: any) => {
            console.log("Boundary Box API Response:", boundaryData);
            this.coordinates = boundaryData["data"];
          },
          error: (error) => {
            console.error("Boundary Box API Error:", error);
            this.coordinates = []; // Reset if error occurs
          }
        });
    });
  }
  
  updateFeedback(imageName: string, boundingBox: any, feedbackType: 'accept' | 'ignore', event: Event) {
    if(this.isDb2===true){
      this.dbName="db2";
    } else{
      this.dbName="db1";
    }
    if (!imageName) {
      console.error("Image data is null. Cannot send feedback.");
      return;
    }

    // Extract only the image name from the full URL
    let extractedImageName = imageName.split('/').pop();
    if (extractedImageName) {
      extractedImageName = extractedImageName.split('?')[0];
    } else {
      extractedImageName = "";
    }

    // Save feedback in localStorage
    const feedbackKey = `feedback_${extractedImageName}`;
    localStorage.setItem(feedbackKey, feedbackType);

    // Remove the button container from the DOM
    const buttonContainer = (event.target as HTMLElement).closest('.feedback-buttons');
    if (buttonContainer) {
      buttonContainer.remove();
    }

    // Update bounding box with feedback information
    boundingBox.is_feedback_provided = true;
    boundingBox.feedback_value = (feedbackType === 'accept') ? 0 : 1;

    const feedbackData = {
      artifact_id: (this.statusModel["artifact_id"]?this.statusModel["artifact_id"]:this.statusModel["_id"]),
      execution_id: this.reportId,
      coordinates: {
        "coordinates": [
          {
            "image_name": extractedImageName,
            "bounding_boxes": [boundingBox],
            "reference": this.image1Url,
            "executed": this.image2Url,
            "browser": this.browser,
            "iteration": this.iteration
          }
        ]
      },
     dbname: this.dbName,

    };

    console.log("Sending feedback:", feedbackData);

    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8');
    this.httpClient.post(this.restService.apis.sendFeedbackUrl.url, feedbackData, { headers: httpHeaders })
      .subscribe({
        next: (response) => console.log("Feedback sent successfully:", response),
        error: (error) => console.error("Error sending feedback:", error)
      });
  }

  isObject(node: any): boolean {
    return typeof node === 'object' && !Array.isArray(node);
  }

  isArray(node: any): boolean {
    return Array.isArray(node);
  }

  isLoopRequired(arrayNode: any, i: number): boolean {
    console.log("Array size: ",arrayNode.length);
    if (arrayNode.length > 1 && arrayNode[i][0]['status'] == '' 
      // && arrayNode[i][0]['command']['name'] != 'loop count') {
      && i > 0) {
        return false
    }
    return true;
  }

  loopFilter(node: any) {
    node = node.filter(item => {
      return !(
        (item[0].status === "" && item[item.length - 1].status === "")
      );
    });
    this.loopsData = node;
    console.log(this.loopsData)
  }


  expandDetails(loopIndex: any) {
    // this.collapsed = !this.collapsed;
    
    const loopList = document.getElementsByName("loopList" + loopIndex)
    Array.from(loopList).forEach(element => {
      element.style.display = "block";
    });
  }

  collapseDetails(loopIndex: any) {
    // this.collapsed = !this.collapsed;
    
    const loopList = document.getElementsByName("loopList" + loopIndex)
    Array.from(loopList).forEach(element => {
      element.style.display = "none";
    });
  }
  acceptChange(box) {
    box.feedback_value == 0
    console.log("Accepted", box)
  }

  rejectChange(box) {
    box.feedback_value == 1
    console.log("Rejected", box)
  }


}
